import { Form } from 'antd';
import dayjs from 'dayjs';

import type { ModelProductsDecomission } from '@app/api/Products';
import {
  useGoodsWriteOff,
  useWarehouseSourceOperationEffects,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/hooks';
import {
  AddAvailableProductsModal,
  AvailableProductsSection,
  OperationCommentField,
  OperationDateField,
  OperationFormButtons,
  OperationWarehouseSelect,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/ui';
import { toOperationDateTime } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/utils';

export const GoodsWriteOff = () => {
  const {
    form,
    onFinish,
    isPageLoading,
    getWarehouseProductsForSelectionHandler,
    warehousesOptions,
    warehouseProducts,
    isOpenAddAvailableProductsModal,
    onCloseAddAvailableProductsModal,
    onOpenAddAvailableProductsModal,
    onAdd,
    suppliersOptions,
    selectedProducts,
    products,
    formValues,
    totalCount,
    onDelete,
    setSelectedProducts,
    isProductsLoading,
    isLoadingDecomissionProducts,
  } = useGoodsWriteOff();

  useWarehouseSourceOperationEffects({
    getWarehouseProductsForSelectionHandler,
  });

  return (
    <>
      <Form<ModelProductsDecomission>
        form={form}
        className="product-operation-form"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 5 }}
        labelAlign="left"
        disabled={isPageLoading || isLoadingDecomissionProducts}
        initialValues={{
          DateDecomission: toOperationDateTime(dayjs()),
          WarehouseId: undefined,
          Comment: '',
          Products: [],
        }}
        onFinish={onFinish}
      >
        <OperationDateField name="DateDecomission" />
        <OperationWarehouseSelect
          name="WarehouseId"
          label="Со склада"
          options={warehousesOptions}
          onChange={() => {
            form.setFieldsValue({ Products: [] });
            setSelectedProducts([]);
          }}
        />
        <AvailableProductsSection
          form={form}
          products={products}
          warehouseProducts={warehouseProducts}
          onDelete={onDelete}
          isAddDisabled={!formValues?.WarehouseId}
          isPageLoading={isPageLoading}
          isMutationLoading={isLoadingDecomissionProducts}
          onOpenModal={onOpenAddAvailableProductsModal}
          totalCount={totalCount}
        />
        <OperationCommentField />
        <OperationFormButtons
          submitLabel="Принять"
          isLoading={isLoadingDecomissionProducts}
          onReset={() => form.resetFields()}
        />
      </Form>
      <AddAvailableProductsModal
        isOpen={isOpenAddAvailableProductsModal}
        onClose={onCloseAddAvailableProductsModal}
        onAdd={onAdd}
        productList={products || []}
        suppliersOptions={suppliersOptions}
        warehousesOptions={warehousesOptions}
        selectedProducts={selectedProducts}
        warehouseProducts={warehouseProducts}
        isLoading={isProductsLoading}
      />
    </>
  );
};
